import type { NameStatusEntry, NumstatEntry } from '../parse/types.js';

export function collectMovedSourcePaths(
  nameEntries: NameStatusEntry[],
  numByPath: Map<string, NumstatEntry & { pathInRepo?: string }>,
): Set<string> {
  const sources = new Set<string>();
  for (const entry of nameEntries) {
    if (entry.change === 'moved' && entry.oldPathInRepo) sources.add(entry.oldPathInRepo);
  }
  for (const entry of numByPath.values()) {
    if (entry.oldPathInRepo) sources.add(entry.oldPathInRepo);
  }
  return sources;
}
